angular.module('jv.requisition.index.controller', [
    'jv.choose.add.reqs.form.directive',
    'jv.common.numberFormatter.directive',
    'jv.Common.ModalWrapper',
    'jv.Common.MouseoverTooltip'
])
    .controller('ReqsIndexCtrl',['$scope', '$location', 'Reqs', '$filter', 'hireCustomer', '$timeout',
    'NOTE_MAX_LENGTH', '$window', '$rootScope', 'jvSearchSerializer', '$localStorage', '$route','jvHireUrlService', '$log',
    function($scope, $location, Reqs, $filter, hireCustomer, $timeout, NOTE_MAX_LENGTH, $window, $rootScope,jvSearchSerializer, $localStorage, $route, jvHireUrlService, $log) {
    var dateFilterList = [{
        'searchId': 'createdDate',
        'filterOption': 'CreatedDate'
    }, {
        'searchId': 'openDate',
        'filterOption': 'OpenDate'
    }, {
        'searchId': 'closedDate',
        'filterOption': 'ClosedDate'
    }, {
        'searchId': 'filledDate',
        'filterOption': 'FilledDate'
    }];
    $scope.search = ((function() {
        var url = $window.location.href && new URL($window.location.href);
        return url && url.searchParams && url.searchParams.get('q');
    })());
    var defaultFilters = {
        q: '',
        sortBy: '',
        jobStateValue: [],
        recruiterIds: [],
        hiringManagerIds: [],
        subsidiaryId: [],
        regionIds: [],
        locationIds: [],
        departmentIds: [],
        categoryIds: [],
        typeIds: [],
        createdDate: {
            'to': null,
            'from': null,
            'type': null
        },
        closedDate: {
            'to': null,
            'from': null,
            'type': null
        },
        filledDate: {
            'to': null,
            'from': null,
            'type': null
        },
        openDate: {
            'to': null,
            'from': null,
            'type': null
        },
        awaitingApproval: false,
        page: 0,
        maxResults: 10,
        postingType: [],
        order: ''
    };
    var initialSelection; //If HM, Recruiter is a filter, then name etc is fetched in this object.
    var serializedParams;
    $scope.data = {
        locationList: [],
        hiringManagerList: [],
        recruiterList: [],
        departmentList: [],
        reqTemplate : ''
    };
    var searchInProgress = false;
    $scope.actions = {};
    $scope.hireCustomer = hireCustomer;
    $scope.employeeMultipleSelect = Reqs.employeeMultipleSelect;
    $scope.locationMultiSelect = Reqs.locationMultiSelect;
    $scope.departmentMultiSelect = Reqs.departmentMultiSelect;
    $scope.reqTemplateSelect = Reqs.reqTemplateSelect;
    $scope.filters = angular.copy(defaultFilters);
    $scope.filterDates = angular.copy(defaultFilters);
    $scope.requisitions = {};
    $scope.selectedRows = {};
    $scope.helpOpen = false;
    $scope.isActiveEnabled = false;
    $scope.loadJobOwners = false;
    $scope.loadDepartments = false;
    $scope.disabledeptfiltersload = false;
    $scope.clearLocSearchRegionFlag = false;
    $scope.selectionError = '';
    $scope.enableSkipApproval = false;
    $scope.skipApprovalButtonView = false;
    $scope.sorts = {
        'lastUpdated': $scope.i18n.UPDATED,
        'title': $scope.i18n.TITLE,
        'requisitionId': $scope.i18n.REQUISITION_ID,
        'location': $scope.i18n.LOCATION,
        'status': $scope.i18n.STATUS,
        'listCreateDate': $scope.i18n.CREATED
    };
    $scope.bulkChangeStatusErrorMessage = '';
    $scope.bulkChangeStatusInfoMessage = '';

    // Remove obsolete bulk edit local storage data.
    delete $localStorage.requisitionsBulkEditFormData;
    delete $localStorage.requisitionsBulkEditValidJobsForSFA;
    delete $localStorage.requisitionsBulkEditFormDataToSave;

    $scope.updateModalState = function (modal, modalState) {
        $scope[modal] = Object.assign({}, $scope[modal], modalState);
    };

    $scope.openModal = function (modal) {
        $scope.updateModalState(modal, { show: true });
    };

    $scope.closeModal = function (modal, closeModalCallback, shouldRefresh = false) {
        $scope.updateModalState(modal, { show: false });
        document.body.classList.remove('no-scroll');
        closeModalCallback(shouldRefresh);
    };
    
    function handleBulkChangeStatusError (error) {
        $scope.bulkChangeStatusInfoMessage = '';
        $scope.bulkChangeStatusErrorMessage = error;
        $scope.flags.loading = false;
    }
    
    $scope.closeBulkChangeStatusModalCallback = function (shouldRefresh) {
        // Reset info message
        $scope.bulkChangeStatusInfoMessage = '';
        // Reset the error message
        handleBulkChangeStatusError('');
        shouldRefresh && refresh();
    };

    const bulkActionsStatusConfig = {
        ON_HOLD: {
            label: $scope.i18n.BULK_ACTION_STATUS_ON_HOLD,
            value: 'On Hold',
            onBulkStatusChange
        },
        OPEN: {
            label: $scope.i18n.BULK_ACTION_STATUS_OPEN,
            value: 'Open',
            onBulkStatusChange
        },
        CLOSE: {
            label: $scope.i18n.BULK_ACTION_STATUS_CLOSE,
            value: 'Close',
            onBulkStatusChange
        },
        SUBMIT_FOR_APPROVAL: {
            label: $scope.i18n.BULK_ACTION_STATUS_SUBMIT_FOR_APPROVAL,
            value: 'Submit for Approval',
            onBulkStatusChange
        },
        RETRACT: {
            label: $scope.i18n.BULK_ACTION_STATUS_RETRACT,
            value: 'Retract',
            onBulkStatusChange
        },
        APPROVE: {
            label: $scope.i18n.BULK_ACTION_STATUS_APPROVE,
            value: 'Approve',
            onBulkStatusChange
        },
        REJECT: {
            label: $scope.i18n.BULK_ACTION_STATUS_REJECT,
            value: 'Reject',
            onBulkStatusChange
        }
    };

    /**
     * Default function implementation for onBulkStatusChange for all the status changes
     * however, we can also implement separate function in bulkActionsStatusConfig object for specific status change if required
     */
    function onBulkStatusChange(selectedStatus, selectedJobEIds) {
        $scope.flags.loading = true;
        const postData = {
            jobEIds: selectedJobEIds,
            status: selectedStatus
        };
        Reqs.validateBulkChangeStatus(postData)?.then((validationResponse) => {
            const errorCode = validationResponse?.data?.errorCode;

            if (errorCode) {
               handleBulkChangeStatusError($scope.i18n[errorCode]);
               return;
            }

            if (selectedStatus === bulkActionsStatusConfig.SUBMIT_FOR_APPROVAL.value) {
                $localStorage.requisitionsBulkSFASelectedReqs = $scope.selectedJobs;
                $timeout(() => {
                    $window.location = `${$scope.requisitions.forumBaseUrl}jhire/modules/requisitions/bulkSFA.html`;
                }, 100);
                return;
            }

            Reqs.bulkChangeStatus(postData, function (response) {
                $scope.flags.loading = false;
                $scope.selectAll = false;
                const { processedJobEIds, unprocessedJobEIds } = response.data;
                $scope.processedJobEIds = [];
                $scope.unprocessedJobEIds = [];
                $scope.selectedJobs.forEach((job) => {
                    if (processedJobEIds.includes(job.EId)) {
                        $scope.processedJobEIds.push(job);
                    }
                    if (unprocessedJobEIds.includes(job.EId)) {
                        $scope.unprocessedJobEIds.push(job);
                    }
                });
                $scope.closeModal('bulkChangeStatusModal', $scope.closeBulkChangeStatusModalCallback);
                if ($scope.unprocessedJobEIds.length === 0) {
                    $scope.showMsg('BULK_ACTION_STATUS_CHANGE_SUCCESS');
                    refresh();
                    return;
                }
                $scope.openModal('bulkChangeStatusResultModal');
            }, function (error) {
                handleBulkChangeStatusError(JSON.stringify(error?.data));
            });
        });
    }

    const bulkActionMethods = {
        BULK_ACTION_CHANGE_STATE: function () {
            $scope.flags.loading = true;

            Reqs.bulkChangeStatusDropDown(function (response) {
                $scope.flags.loading = false;
                const mappedOptions = response?.data?.changeStatusDropDowns?.map((key) => {
                    return {
                        key,
                        label: bulkActionsStatusConfig[key].label,
                        value: bulkActionsStatusConfig[key].value
                    };
                });
                $scope.bulkChangeStatusDropDownOptions = mappedOptions;
                $scope.skipApprovalButtonView = false;
                $scope.openModal('bulkChangeStatusModal');
            },
            function (error) {
                $log.error(error);
            });
        },
        BULK_ACTION_BULK_EDIT_REQUISITIONS: function () {
            if (!$scope.filters.hasOwnProperty('reqTemplateIds') || $scope.filters.reqTemplateIds=== '') {
                $scope.selectionError = $scope.i18n.BULK_ACTION_EDIT_REQUISITIONS_TEMPLATE_SELECT_ERROR_MSG;
                return;
            } else {
                const matchedTemplateObj = Reqs.requisitionTemplatesList.find((template) => template.eid === $scope.filters.reqTemplateIds);

                if (matchedTemplateObj && matchedTemplateObj.reqStatus === 'Inactive') {
                    $scope.selectionError = $scope.i18n.BULK_ACTION_EDIT_REQUISITIONS_INACTIVE_TEMPLATE_ERROR_MSG;
                    return;
                }
            }
            $localStorage.requisitionsBulkEditSelectedReqs = $scope.selectedJobs;
            $timeout(() => {
                $window.location = `${$scope.requisitions.forumBaseUrl}jhire/modules/requisitions/bulkEditReqs.html?templateId=${$scope.filters.reqTemplateIds}`;
            }, 100);
        },
        BULK_ACTION_SEND_JOBVITE: function () {
            for (const [key, value] of Object.entries($scope.selectedRows)) {
                if (value && !$scope.requisitions.jobs[key]?.sendJobvite) {
                    $scope.selectionError = $scope.i18n.BULK_ACTION_SEND_JOBVITE_ERROR_MSG;
                    return;
                }
            }
            $scope.sendJobvite($scope.selectedRows);
        }
    };

    function setSelectedJobs (selectedRows) {
        const rows = [];

        angular.forEach(selectedRows, function(isSelected, key) {
            if (isSelected) {
                rows.push({
                    EId: $scope?.requisitions?.jobs?.[key]?.EId,
                    title: $scope?.requisitions?.jobs?.[key]?.title
                });
            }
        });

        $scope.selectedJobs = rows;
    }

    function getSelectedJobEIds () {
        return $scope?.selectedJobs?.map((job) => {
            return job.EId;
        });
    }

    $scope.handleBulkChangeStatus = function (selectedStatus) {
        $scope.skipApprovalButtonView = false;
        const selectedJobEIds = getSelectedJobEIds();
        const postData = {
            jobEIds: selectedJobEIds,
            status: selectedStatus.value
        };
        if(selectedStatus.value === bulkActionsStatusConfig.CLOSE.value || selectedStatus.value === bulkActionsStatusConfig.SUBMIT_FOR_APPROVAL.value){
            Reqs.bulkChangeStatusOnSelection(postData, function (response) {
                $scope.bulkChangeStatusInfoMessage = $scope.i18n[response.data.errorCode];
                $scope.enableSkipApproval = response?.data?.enableSkipApproval || false;
                $scope.skipApprovalButtonView = $scope.enableSkipApproval;
            });
        }
        // Reset the error message
        handleBulkChangeStatusError('');
    };

    $scope.handleBulkChangeStatusSubmit = function (selectedStatus) {
        const selectedJobEIds = getSelectedJobEIds();
        const { key, value } = selectedStatus || {};
        if (bulkActionsStatusConfig[key]?.onBulkStatusChange) {
            bulkActionsStatusConfig[key]?.onBulkStatusChange(value, selectedJobEIds);
        } else {
            return;
        }
    };

    $scope.bulkSkipApproval = function () {
        $scope.flags.loading = true;
        const data = { skipApprovalProcess: true, jobEIds: getSelectedJobEIds() };
        Reqs.bulkSubmitForApproval(data, function () {
            window.location = '/jhire/modules/requisitions/list.html';
            $scope.flags.loading = false;
        });
    };

    delete $scope.sorts.location;
    if (!$window._enableTTF) {
        delete $scope.sorts.timeToFill;
    }
    //This is to open the filter panel by default
    $scope.flags.expanded = true;
    $scope.openHelp = function(job) {
        if ($scope.helpOpen) {
            angular.forEach($scope.requisitions.jobs, function(job) {
                if (job.help) {
                    job.help = false;
                    $scope.helpOpen = false;
                }
            });
            job.help = true;
            $scope.helpOpen = true;
        } else {
            job.help = true;
            $scope.helpOpen = true;
        }
    };
    // Temp variable used while processing all regions selection.
    $scope.locations = [];
    $scope.departments= [];
    //Variable to monitor the filter changes from JSP end only i.e this variable will be set to true only on user-action.
    $scope.filterChange = false;
    /**
     * Monitors the filters for changes and refreshes the table accordingly
     */
    var ignoreFilterChange = false;
    var allLocations = [];

    //Function called on JSP load which sets "disabledeptfiltersload" variable and this variable is used further to protect new
    //loading technique functions
    $scope.setDepartmentsLoadStatus = function(value) {
        $scope.disabledeptfiltersload = value;
    };

    $scope.truncateText = function (value, length) {
        return value?.length > parseInt(length) ? `${value?.slice(0, length)}...` : value;
    };
    
    $scope.textReduceToString = function (value) {
        const agencyUsers = value.map((v) => {
            return `${v.fullName}(${v.email})`;
        });
        return agencyUsers;
    };
    
    // Function to handle the selection of all rows for bulk actions feature
    $scope.$watch('selectAll', function () {
        if ($scope?.requisitions?.jobs) {
            angular.forEach($scope?.requisitions?.jobs, function(_, index) {
                $scope.selectedRows[index] = $scope.selectAll;
            });
        }
    });
    
    $scope.dateFormatByAccount = function (value) {
        if (value && !isNaN(new Date(value).getTime())) {
            return moment(value).locale(window._jvselfUser.locale.languageTag).tz(window._jvselfUser.locale.timezone).format(window._jvselfUser.locale.userDate.shortDate().toUpperCase());
        }
        return '';
    };
    //Because date is a complicated object, ensuring that dates is handled seperately and updates the filters
    //only if certain conditions are met.
    //1) type, to, from have values which means a date option is selected.
    //2) type, to, from are all null which means date option has been cleared.
    //Needed to do this because of the way jv-date-range-filter first changes type and then updates to, from which was
    //resulting in search query fired multiple times.
    $scope.$watch('filterDates', function watchFilterDates(newValue, oldValue, $scope) {
        if (angular.equals(newValue, oldValue)) {
            return;
        }
        var updateFilter = function(dateName, newValue, $scope) {
            if (newValue[dateName]) {
                if (newValue[dateName].type != null && newValue[dateName].to != null && newValue[dateName].from != null) {
                    $scope.filters[dateName] = angular.copy(newValue[dateName]);
                }
                if (newValue[dateName].type === null && newValue[dateName].to !== null && newValue[dateName].from !== null) {
                    $scope.filters[dateName] = {
                        'to': null,
                        'from': null,
                        'type': null
                    };
                    delete $scope.filters[dateName + 'To'];
                    delete $scope.filters[dateName + 'From'];
                    delete $scope.filters[dateName + 'Type'];
                }
            }
        };
        angular.forEach(dateFilterList, function(dateFilterName) {
            updateFilter(dateFilterName.searchId, newValue, $scope);
        });
    }, true);

    var updateFilterDates = function(initFilters) {
        angular.forEach(dateFilterList, function(dateFilterName) {
            $scope.filterDates[dateFilterName.searchId].to = initFilters[dateFilterName.searchId + 'To'];
            $scope.filterDates[dateFilterName.searchId].from = initFilters[dateFilterName.searchId + 'From'];
            $scope.filterDates[dateFilterName.searchId].type = initFilters[dateFilterName.searchId + 'Type'];

            delete initFilters[dateFilterName.searchId + 'To'];
            delete initFilters[dateFilterName.searchId + 'From'];
            delete initFilters[dateFilterName.searchId + 'Type'];
        });
    };

    //this is bound to the dateRangeFilter directive and is called on change of the date filters dropdown.
    $scope.onFilterChange = function(setValue){
        if(angular.isDefined(setValue)){
            return $scope.filterChange = setValue;
        }
        return $scope.filterChange;
    };

    //Function to initialize departments filters from departmentList when dropdown is clicked
    var initDepartments = function() {
        var departmentList = [];
        if ($scope.data.departmentList && $scope.data.departmentList.length) {
            angular.forEach($scope.data.departmentList, function(value) {
                (value.EId)?departmentList.push(value.EId):departmentList.push(value);
            });
        }
        $scope.filters.departmentIds = departmentList;
        $scope.loadDepartments = true;
    };

    $scope.$watch('filters', function watchFilters(newValue, oldValue, $scope) {
        if ((ignoreFilterChange || angular.equals(newValue, oldValue)) && !$scope.filterChange && !$scope.clearLocSearchRegionFlag)  {
            ignoreFilterChange = false;
            return;
        }
        //All new Department loading technique changes are protected under this flag "disabledeptfiltersload"
        if($scope.disabledeptfiltersload && newValue.departmentIds.length===0 && $scope.data.departmentList.length>0) {
            initDepartments();
        }


        //set the filterChange to false
        $scope.filterChange = false;
        // Pagination
        if (newValue.page === oldValue.page && !$.isEmptyObject(newValue)) {
            $scope.quickView = null; // Stop Quick View Pop Up On Filter Change
            $scope.filters.page = 0;
        }
        // Include Direct Reports
        if (newValue.hiringManagerIds && !newValue.hiringManagerIds.length && newValue.directReports) {
            delete newValue.directReports;
            ignoreFilterChange = true;
        }

        //Removing Status from sort by dropdown for employee login
        if (!($scope.filterOptions.JobStates && $scope.filterOptions.JobStates.length >= 1) && $scope.sorts.status) {
            delete $scope.sorts.status;
        }
        // Searches
        //$scope.search = newValue.q;
        //Fix for HIRE-5993 - NV
        newValue.q = $scope.search;
        if (newValue.q !== oldValue.q) {
            if (newValue.q) {
                $scope.sorts.relevance = $scope.i18n.RELEVANCE;
                if ($scope.filters.sortBy !== 'relevance') { ignoreFilterChange = true; }
                $scope.filters.sortBy = 'relevance';
            } else {
                if ($scope.requisitions && $scope.requisitions.jobFilter && $scope.filters.sortBy !== $scope.requisitions.jobFilter.sortBy) {
                    $scope.filters.sortBy = $scope.requisitions.jobFilter.sortBy;
                    delete $scope.sorts.relevance;
                    ignoreFilterChange = true;

                }
            }
        }
        //This is to rerender the location select when user changes the region
        if (newValue.regionIds && !angular.equals(newValue.regionIds, oldValue.regionIds)) {
            $scope.loadLocationSelect = false;
        }
        // Locations
        if ($scope.filterOptions && !angular.equals(newValue.regionIds, oldValue.regionIds)) {
            // If the region changes, show the subset of locations available
            $scope.initLocation(newValue.regionIds);
        }
        // Awaiting approval checkbox
        if (newValue.awaitingApproval !== oldValue.awaitingApproval && newValue.awaitingApproval) {
            $scope.isActiveEnabled = true;
        } else if (newValue.awaitingApproval !== oldValue.awaitingApproval && !newValue.awaitingApproval) {
            $scope.isActiveEnabled = false;
        }
        // Refresh table
        refresh();
    }, true);
    /**
     * Check all boxes if they are enabled
     * @return {[type]} [description]
     */
    $scope.$watch('checkAll', function watchCheckAll() {
        if ($scope.requisitions && $scope.requisitions.jobs) {
            angular.forEach($scope.requisitions.jobs, function(job, index) {
                if ($scope.filters.awaitingApproval || job.sendJobvite) {
                    $scope.selectedRows[index] = $scope.checkAll;
                }
            });
        }
    });
    $scope.approveModal = {
        maxLength: NOTE_MAX_LENGTH,
        open: function(reject) {
            $scope.approveModal.notes = '';
            $scope.approveModal.reject = reject;
            $scope.approveModal.show = true;
        },
        ok: function() {
            var rows = [];
            angular.forEach($scope.selectedRows, function(value, key) {
                if (value) {
                    rows.push($scope.requisitions.jobs[key].EId || $scope.requisitions.jobs[key].eid);
                }
            });
            var options = {
                j: rows,
                notes: $scope.approveModal.notes,
                reject: $scope.approveModal.reject
            };
            Reqs.approve(options, function(response) {
                $scope.approveModal.notes = '';
                $scope.approveModal.show = false;
                var message = $scope.approveModal.reject && i18n.notices.rejected || i18n.notices.approved;
                $scope.$root.notice = $scope.format(message, rows.length);
                $scope.requisitions.jobCount = response.jobCount;
                $scope.requisitions.jobs = response.jobs;
                $scope.selectedRows = {};
                $scope.checkAll = false;
                $scope.filters.awaitingApproval = false;
            });
        }
    };
    $scope.enableSend = function() {
        var enable = false;
        angular.forEach($scope.selectedRows, function(value) {
            if (value) {
                enable = true;
            }
        });
        return enable;
    };
    $scope.showTTFTooltip = false;
    $scope.resort = function(key) {
        if (key !== $scope.filters.sortBy) {
            $scope.filters.sortBy = key;
            $scope.filters.order = 'asc';
        }
        if (!$scope.openSortBy) { $scope.openSortBy = !$scope.openSortBy; }
    };
    $scope.actionChange = function (key, rows) {
        if (!$scope.enableSend()) {
            $scope.selectionError = $scope.i18n.BULK_ACTION_SELECTION_ERROR_MSG;
            return;
        } else {
            $scope.selectionError = '';
        }
        
        setSelectedJobs(rows);
        if (bulkActionMethods[key]) {
            bulkActionMethods[key]();
        } else {
            return;
        }
        if (!$scope.openAction) { $scope.openAction = !$scope.openAction; }
    };
    $scope.changeSort = function(order) {
        if ($scope.filters.order !== order) {
            $scope.filters.order = order;
        }
    };
    $scope.searchGo = function(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        //set the filterChange to true, so the keyword search gets processed
        $scope.setFilterChange();
        $scope.filters.q = $scope.search;
    };

    var initJobOwners = function() {
        var hiringManagerList = [];
        var recruiterList = [];
        if ($scope.data.hiringManagerList && $scope.data.hiringManagerList.length) {
            angular.forEach($scope.data.hiringManagerList, function(value) {
                if (value.EId) {
                    hiringManagerList.push(value.EId);
                } else {
                    hiringManagerList.push(value);
                }
            });
        }
        $scope.filters.hiringManagerIds = hiringManagerList;

        if ($scope.data.recruiterList && $scope.data.recruiterList.length) {
            angular.forEach($scope.data.recruiterList, function(value) {
                if (value.EId) {
                    recruiterList.push(value.EId);
                } else {
                    recruiterList.push(value);
                }
            });
        }
        $scope.filters.recruiterIds = recruiterList;
        $scope.loadJobOwners = true;
    };

    $rootScope.$on('$routeChangeSuccess',function(){
        //to fix jv.js's implementation for routechangestart
        $scope.flags.loading = false;
    });

    var updateSerializedSearch = function(filters) {
        var serializedParams = jvSearchSerializer.serialize(filters);
        if (serializedParams !== $scope.params.query) {
            $localStorage.reqSearchFilters = filters;
            $location.path('/q/' + serializedParams).search('').replace();
        }
    };
    /**
     * Refreshes the table with currently set filters
     */
    function refresh(readMode, forceSearch) {
        //A search is already in progress. Do not fire again.
        //retrun only if any search is in progress and clearLocSearchRegionFlag is false
        if (searchInProgress  && !$scope.clearLocSearchRegionFlag) {
            return;
        }
        searchInProgress = true;
        $scope.flags.loading = true;
        $scope.selectionMsg = false;
        Reqs.list(function(requisitions, forceSearch) {
            if (requisitions.forumBaseUrl) {
                $scope.$root.forumBaseUrl = requisitions.forumBaseUrl;
            }
            if ($.isEmptyObject($scope.requisitions) || $scope.filters.clear) {
                // ignoreFilterChange = true;
                if ($scope.filters.clear) {
                    ignoreFilterChange = true;
                    delete $scope.filters.clear;
                }
                if ($scope.searchAllReq && requisitions && requisitions.jobFilter) {
                    requisitions.jobFilter.sortBy = 'relevance';
                }
                $scope.reset(requisitions.jobFilter, forceSearch);

                if($scope.disabledeptfiltersload) {
                    //This method is used to set the departmentIds when refresh happens
                    //from filters if selected and got back from call(initialSelection)
                    $scope.setDepartmentsOnRefresh(forceSearch);
                    initDepartments();
                    $scope.loadDepartments=true;
                }
                $scope.initLocation($scope.filters.regionIds);
                initJobOwners();
            }
            // If the page had to be progressed while quickView is active
            if ($scope.quickView && $scope.quickView.show === 'requisitions') {
                  $scope.quick();
            }
            $scope.requisitions = requisitions;
            if ($scope.requisitions.bulkActions) {
                const bulkActionsDisplayOrder = ['BULK_ACTION_CHANGE_STATE', 'BULK_ACTION_BULK_EDIT_REQUISITIONS', 'BULK_ACTION_SEND_JOBVITE'];

                bulkActionsDisplayOrder.forEach((key) => {
                    if ($scope?.requisitions?.bulkActions?.hasOwnProperty(key)) {
                        $scope.actions[key] =  { name: $scope.i18n[key], visibility: $scope?.requisitions?.bulkActions?.[key]};
                    }
                });
            }
            if (requisitions && requisitions.ColumnHeaders && requisitions.ColumnHeaders.indexOf('TTF') !== -1) {
                $scope.sorts['timeToFill'] = $scope.i18n.ESTIMATED_TTF;
            }
            $scope.selectedRows = {};
            $scope.checkAll = false;
            $scope.selectAll = false;
            $scope.flags.loading = false;
            $scope.searchAllReq = false;
            $scope.clearLocSearchRegionFlag = false;
            if (requisitions.msgInfo) {
                $scope.showMsg(requisitions.msgInfo);
            }
            updateSerializedSearch(angular.copy($scope.filters));
            searchInProgress = false;
        }, angular.copy($scope.filters), readMode, $scope.searchAllReq, forceSearch);
    }

    $scope.setDepartmentsOnRefresh = function(forceSearch) {
        var forceSearchDepartmentIds= $scope.filters.departmentIds;
        if (!angular.isUndefined(initialSelection.departments) && initialSelection.departments.length > 0 && !forceSearch) {
            $scope.data.departmentList = [];
            for (var iDep = 0; iDep < initialSelection.departments.length; iDep++) {
                $scope.data.departmentList.push(initialSelection.departments[iDep].EId);
            }
        } else {
            $scope.data.departmentList = forceSearchDepartmentIds;
        }
    };

    $scope.reset = function(jobFilter, forceSearch) {
        if (jobFilter) {
            // Prevents the $watch(filters) from making another ajax request
            var forceSearchLocationIds = $scope.filters.locationIds;
            var forceHiringManagerIds = $scope.filters.hiringManagerIds;
            var forceRecruiterIds = $scope.filters.recruiterIds;

            $scope.filters = angular.extend({}, defaultFilters, jobFilter);
            $scope.filterOptions = angular.copy($scope.filterOptions);
            if (!angular.isUndefined(initialSelection.hiringManagers) && initialSelection.hiringManagers.length  && !forceSearch) {
                var hiringManagerIds = initialSelection.hiringManagers.map(function(employee) {
                    return employee.EId;
                });
                $scope.filters.hiringManagerIds = hiringManagerIds;
                $scope.data.hiringManagerList = hiringManagerIds;
            } else {
                $scope.data.hiringManagerList = forceHiringManagerIds;
            }
            if (!angular.isUndefined(initialSelection.recruiters) && initialSelection.recruiters.length && !forceSearch) {
                var recruiterIds = initialSelection.recruiters.map(function(employee) {
                    return employee.EId;
                });
                $scope.filters.recruiterIds = recruiterIds;
                $scope.data.recruiterList = recruiterIds;
            } else {
                $scope.data.recruiterList = forceRecruiterIds;
            }

            if (!angular.isUndefined(initialSelection.locations) && initialSelection.locations.length > 0 && !forceSearch) {
                $scope.data.locationList = [];
                for (var i = 0; i < initialSelection.locations.length; i++) {
                    $scope.data.locationList.push(initialSelection.locations[i].EId);
                }
            } else {
                $scope.data.locationList = forceSearchLocationIds;
            }
            /**
            * if the url doesn't have a query param for searchText, check if the jobFilters have and populate it from there
            * scenario : have a search text > refresh the page > search text gets cleared even though the search results honour the text
            */
            $scope.search = initialSelection.searchText || (angular.isDefined($scope.filters) ? $scope.filters.q : '');
            updateFilterDates(jobFilter);
        } else {
            ignoreFilterChange = false;
            // Must be unset after initial clearing request
            initialSelection = {};
            delete $scope.sorts.relevance;
            $scope.filters.clear = 'clear';
            $scope.data.locationList = [];
            $scope.data.hiringManagerList = [];
            $scope.data.recruiterList = [];
            $scope.data.reqTemplate = '';
            if($scope.disabledeptfiltersload) {
                $scope.data.departmentList = [];
                $scope.loadDepartments = false;
            }
            $scope.loadLocationSelect = false;
            $scope.loadJobOwners = false;
        }
    };
    $scope.recordsEnd = function() {
        if ($scope.requisitions.jobFilter) {
            return Math.min($scope.requisitions.jobFilter.maxResults * ($scope.filters.page + 1), $scope.requisitions.jobCount);
        }
    };
    $scope.recordsStart = function() {
        if ($scope.requisitions.jobFilter) {
            return $scope.requisitions.jobFilter.maxResults * $scope.filters.page + 1;
        }
    };
    $scope.next = function() {
        if ($scope.filters.page < $scope.requisitions.jobCount / $scope.requisitions.jobFilter.maxResults - 1) {
            $scope.filters.page++;
            $scope.quickView = null; // Stop Quick View Pop Up On Pagination
        }
    };
    $scope.prev = function() {
        if ($scope.filters.page !== 0) {
            $scope.filters.page--;
            $scope.quickView = null; // Stop Quick View Pop Up On Pagination
        }
    };
    var massageMultiLocationData = function() {
        var locationList = [];
        angular.forEach($scope.data.locationList, function(value) {
            if (value.EId) {
                locationList.push(value.EId);
            } else {
                locationList.push(value);
            }
        });
        $scope.filters.locationIds = locationList;
    };
    $scope.initLocation = function(selectedRegion) {
        $scope.filterOptions.selectedLocations = [];
        if (selectedRegion && selectedRegion.length === 1) {
            angular.forEach($scope.filterOptions.Locations, function(obj) {
                if (obj.key === selectedRegion[0]) {
                    $scope.filterOptions.selectedLocations = obj.value;
                }
            });
        } else {
            if (allLocations && allLocations.length > 0) {
                $scope.filterOptions.selectedLocations = angular.copy(allLocations);
            } else {
                angular.forEach($scope.filterOptions.Locations, function(obj) {
                    $scope.locations = $scope.locations.concat(obj.value);
                });
                // Remove duplicates from locations
                $scope.filterOptions.selectedLocations = allLocations = $scope.uniqueArray($scope.locations, 'EId');
            }
        }
        // Unset the location if it's not found in $scope.locations, but this will cause another $watch so restart now
        if ($scope.filters.locationIds && !$filter('filter')($scope.filterOptions.selectedLocations, {
                EId: $scope.filters.locationIds
            }).length) {
            $scope.filters.locationIds = [];
            ignoreFilterChange = true;
        }
        if ($scope.data.locationList.length) {
            massageMultiLocationData();
        }
        $timeout(function() {
            $scope.loadLocationSelect = true;
        });
    };

    $scope.$watch('data', function (newVal, oldVal) {
        if (newVal && !angular.equals(newVal, oldVal)) {
            if (!angular.equals(oldVal.locationList, newVal.locationList) && newVal.locationList.length) {
                massageMultiLocationData();
            } else if (newVal.locationList.length === 0) {
                $scope.filters.locationIds = [];
                $scope.clearLocSearchRegionFlag = true;
            }
            if ($window._isBulkEditRequisitionDetailsEnabled) {
                if (newVal && newVal.reqTemplate) {
                    $scope.filters.reqTemplateIds = newVal.reqTemplate.eid;
                } else {
                    $scope.filters.reqTemplateIds = '';
                }
                $scope.filterChange = false;
                $scope.clearLocSearchRegionFlag = false;
            }
            if (!angular.equals(oldVal.hiringManagerList, newVal.hiringManagerList)) {
                initJobOwners();
            } else {
                if (newVal.hiringManagerList.length === 0) {
                    $scope.filters.hiringManagerIds = [];
                }
            }

            if (!angular.equals(oldVal.recruiterList, newVal.recruiterList)) {
                initJobOwners();
            } else {
                if (newVal.recruiterList.length === 0) {
                    $scope.filters.recruiterIds = [];
                }
            }
            if($scope.disabledeptfiltersload) {
                if (!angular.equals(oldVal.departmentList, newVal.departmentList)) {
                    initDepartments();
                } else {
                    if (newVal.departmentList.length === 0) {
                        $scope.filters.departmentIds = [];
                    }
                }
            }
            ignoreFilterChange = true;
            refresh();
        }
    }, true);

    /**
     * Opens quickView modal
     */
    $scope.quick = function(index, reqsIndexValue) {
        var id;
        if (reqsIndexValue) {
            $scope.reqsIndex = reqsIndexValue; // Fix For 10266 - To add Pagination when go to reqs button is pressed in Quick View Modal
        }
        if (index === 'next') {
            // Next Item
            if ($scope.lastQuickView === $scope.requisitions.jobs.length - 1) {
                if ($scope.filters.page + 1 < $scope.requisitions.jobCount / $scope.filters.maxResults) {
                    // Get next page
                    $scope.filters.page++;
                    $scope.lastQuickView = 0;
                    $scope.reqsIndex++;
                    index = $scope.lastQuickView;
                    return;
                } else {
                    // End of set
                    return;
                }
            } else {
                index = ++$scope.lastQuickView;
                $scope.reqsIndex++;
            }
        } else if (index === 'prev') {
            // Previous Item
            if ($scope.lastQuickView === 0) {
                if ($scope.filters.page > 0) {
                    // Get prev page
                    ignoreFilterChange = false;
                    $scope.filters.page--;
                    $scope.lastQuickView = $scope.filters.maxResults - 1;
                    $scope.reqsIndex--;
                    index = $scope.lastQuickView;
                    return;
                } else {
                    // Beginning of list
                    return;
                }
            } else {
                index = --$scope.lastQuickView;
                $scope.reqsIndex--;
            }
        } else if (typeof index === 'undefined') {
            index = $scope.lastQuickView;
        } else {
            $scope.lastQuickView = index;
        }
        id = $scope.requisitions.jobs[index].EId;
        Reqs.quickView(id, function(response) {
            $scope.quickView = response.jobDetails;
            $scope.quickView.hasJobAccess = response.hasJobAccess;
            $scope.quickView = $scope.quickView || {};
            $scope.postOptions = response.postOptions;
            $scope.quickView.show = 'requisitions';
        });
    };
    $scope.sendJobvite = function(rows) {
        var accepted = [];
        angular.forEach(rows, function(selected, index) {
            if (selected) {
                accepted.push($scope.requisitions.jobs[index].EId);
            }
        });
        if (accepted.length) {
            window.location = $scope.requisitions.sourceBaseUrl + '/source/share/shareJobvite.html?jobIds=' + accepted.join(',');
        }
    };
        
    $scope.quickReq = function(requisitionId) {
        var data = {};
        data.id = requisitionId;
        $window.jv.modalNew.init(data, 'jv-modalDialog');
    };
    $scope.isEmptyArray = function(arr) {
        if (arr) {
            if (angular.isArray(arr) && arr.length > 0) {
                return false;
            }
            return true;
        }
        return true;
    };
    $scope.getApplicationSearchUrl = function(jobId, jobName) {
        return jvHireUrlService.getCandidateListPageUrl({
                jobIds: jobId,
                jobName: encodeURIComponent(jobName),
                workflowStateIds: '-1'
            });
    };

    /* Populate Page */
    Reqs.filters(function(response) {
        var forceSearch = false;
        var dateFilter = {
            'type': null,
            'from': null,
            'to': null
        };

        //If URL has query, then use that as filters and then make the search call.
        if ($scope.params && $scope.params.query) {
            serializedParams = $scope.params.query;
            var params = jvSearchSerializer.deserialize(serializedParams) || [];
            $localStorage.reqSearchFilters = params;
            $scope.filters = angular.extend({}, defaultFilters, params);
            forceSearch = true;
            ignoreFilterChange = true;
        }

        $scope.filterOptions = response.filters;
        angular.forEach(dateFilterList, function(dateFilterName) {
            if ($scope.filterOptions[dateFilterName.filterOption]) {
                $scope.filterOptions[dateFilterName.filterOption] = angular.copy(dateFilter);
                $scope.filterOptions[dateFilterName.filterOption].searchId = dateFilterName.searchId;
            }
        });

        initialSelection = response.selectedFilter || {};
        if ($scope.search) {
            // $scope.search = initialSelection.searchText = unescape($scope.search);
            $scope.searchAllReq = true;
            $scope.searchGo();
        } else {
            refresh($scope.urlParams().readMode, forceSearch);
        }
    });
    //function to make sure that quickView is nullified on it's close
    $scope.closeQuickView = function(){
        $scope.quickView = null;
    };

    //function to set the scope variable filterChange to true, we're changing the scope variable - filterChange directly in jsp till now,
    //and this doesn't work if the filter element in enclosed in a ng-if condition as the latter creates a child scope for itself.
    $scope.setFilterChange = function(filterChangeValue){
        if(angular.isUndefined(filterChangeValue)){
            $scope.filterChange=true;
            return;
        }
        $scope.filterChange = filterChangeValue;
    };
    ignoreFilterChange = true;

    $scope.handleAddRequisition = function () {
        $scope.showChooseReqsFormModal = true;
    };

    $scope.closeAddRequisition = function () {
        $scope.showChooseReqsFormModal = false;
    };
}])

.directive('stickyColumn', function() {
    return {
      restrict: 'A',
      link: function(scope, element) {

        function handleScroll() {
            const scrollLeft = element[0].scrollLeft;
            if (scrollLeft > 0) {
                element?.find('th:nth-child(2), td:nth-child(2)')?.addClass('highlight-column');
            } else {
                element?.find('th:nth-child(2), td:nth-child(2)')?.removeClass('highlight-column');
            }
        }

        element[0].addEventListener('scroll', handleScroll);

        scope.$on('$destroy', function() {
            if (element[0]) {
                element[0].removeEventListener('scroll', handleScroll);
            }
        });
      }
    };
})

.directive('tooltipClick', function() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            function handleClick() {
                const cell = element?.closest('td');
                const cells = element?.closest('table')?.find('td');

                cells && cells?.css('z-index', 600);
                cell && cell?.css('z-index', 700);
            }

            element?.on('click', handleClick);

            scope.$on('$destroy', function() {
                element?.off('click', handleClick);
            });
        }
    };
});
